import React, { useState } from 'react'
import './AnimatedCircleStatus.css'


export function AnimatedCircleStatus(props) {

	// const [status, setstatus] = useState((typeof props.status !=='undefined' && ['danger' , 'warning' , 'success'].includes(props.status))? props.status : 'none')
	// const [title, settitle] = useState((typeof props.title !=='undefined' && props.title!=='')? props.title : '')
	// const [size, setsize] = useState((typeof props.size !=='undefined' && props.size!==null && ['xsmall' , 'small' ,  'medium' , 'big'].includes(props.size)) ? props.size : 'small')
	// const status = (typeof props.status !=='undefined' && ['danger' , 'warning' , 'monitoring' ,'success'].includes(props.status))? props.status : 'none';
	const status = (typeof props.status !=='undefined' && ['red' , 'yellow' , 'orange', 'blue' ,'green'].includes(props.status))? props.status : 'none';
	const title = (typeof props.title !=='undefined' && props.title!=='')? props.title : '';
	const size = (typeof props.size !=='undefined' && props.size!==null && ['xsmall' , 'small' ,  'medium' , 'big'].includes(props.size)) ? props.size : 'small';

	const sizeIds = {
		xsmall : 'xs',
		small : 'sm',
		medium : 'md',
		big : 'bg',
	}

	return (
		<div 
			data-variation={status} 
			data-status="" 
			className={`status-indicator status-indicator--${status} status-indicator--${sizeIds[size]}  status-indicator--infinite` }
			data-last-checked-at="" 
			data-frequency="" 
			title={title}
			{ ...props}
			>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-main`}></div>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-secondary`}></div>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-tertiary`}></div>
		</div>
	)
}